module.exports = __webpack_public_path__ + "img/Spider Management.63dafcde.svg";